export default __webpack_public_path__ + "static/media/media-document.aecc591d.svg";